<template>
    <v-card outlined shaped>
        <v-card-title>
            
             Disposal Report
            
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="10">
                    <v-text-field
                     v-model="search"
                     append-icon="mdi-magnify"
                     label="Search"
                     single-line
                     hide-details=""
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <vue-excel-xlsx
                        :data="items"
                        :columns="headersExport"
                        :file-name="fileName"
                        :file-type="'xlsx'"
                        :sheet-name="'sheetname'"
                    >
                    <v-btn color="blue-grey" class="ma-2 white--text">
                                Export<v-icon right >mdi-cloud-download</v-icon>
                            </v-btn>
                    </vue-excel-xlsx>
                </v-col>
            </v-row>
            <v-data-table
             :headers="headers"
             :items="items"
             :search="search"
             :items-per-page="10"
             class="elevation-1"
             ></v-data-table>
        </v-card-text>
    </v-card>
</template>
<script>

import reportAPI from '@/services/reportsservice';
import moment from 'moment';

export default
{
    name:'DisposalReport',
    data:function(){
        return {
            search:'',
            fileName:'DisposalReport'+moment(Date.now()).format('YYYY-MM-DD'),
            items:[]
        }
    },
    computed:{
        headers(){
            return [
                //{ text: 'Id', align:'start', sortable:true, value:'radiationId'},
                { text:'Serial Number', align:'start', sortable:true, value:'serialNumber'},
                { text:'Building', align:'start', sortable:true, value:'building'},
                { text:'Floor', align:'start', sortable:true, value:'floor'},
                { text:'Location', align:'start', sortable:true, value:'location'},
                { text: 'Has a Shutter', align:'start' , sortable: true, value:'shutt'},
                { text:'Isotope', value:'isotope'},
                { text:'MCI', align:'start', sortable:true, value:'mci'},
                { text:'Leak Test Interval', value:'leak'},
                //{ text:'Leak Test Reference', align:'start', sortable:true, value:'leakTestReference'},
                { text:'Leak Test Group', align:'start', sortable:true, value:'leakTestGroupCode'},
                { text:'Holder', align:'start', sortable:true, value:'holderCode'},
                { text:'Holder serial Number', align:'start', sortable:true, value:'holderSerialNumber'},
                { text:'P&ID Tag', align:'start', sortable:true, value:'tag'},
                { text:'PO', align:'start', sortable:true, value:'po'},
                { text:'Source', align:'start', sortable:true, value:'source'},
                { text:'MFG', align:'start', sortable:true, value:'mfg'},
                { text:'Use Bulding', align:'start', sortable:true, value:'useBuilding'},
                { text:'Install Status', align:'start', sortable:true, value:'installed'},
                { text:'Secure By Lock and Cable', align:'start', sortable:true, value:'secureByLock'},
                { text:'Reason Not Secure', align:'start', sortable:true, value:'reasonNotSecure'},
                { text:'Received Date', align:'start', sortable:true, value:'receiveDate'},
                { text:'Update', align:'start', sortable:true, value:'update'},
                { text:'Dispose Date', align:'start', sortable:true, value:'disposeDate'},
                { text:'Dispose Site', align:'start', sortable:true, value:'disposeSite'},
                { text:'Dispose MSO', align:'start', sortable:true, value:'disposeMSO'},
                { text:'Transfer Letter Filed', align:'start', sortable:true, value:'verified'}
            ];
        },
        headersExport(){
            return [
                //{ label:'Id',  field:'radiationId'},
                { label:'Serial Number', field:'serialNumber'},
                { label:'Building',  field:'building'},
                { label:'Floor', field:'floor'},
                { label:'Location', field:'location'},
                { label: 'Has a Shutter', field:'shutt'},
                { label:'Isotope', field:'isotope'},
                { label:'MCI', field:'mci'},
                { label:'Leak Test Interval', field:'leak'},
                //{ label:'Leak Test Reference', field:'leakTestReference'},
                { label:'Leak Test Group', field:'leakTestGroup'},
                { label:'Holder', field:'holderCode'},
                { label:'Holder serial Number', field:'holderSerialNumber'},
                { label:'P&ID Tag', field:'tag'},
                { label:'PO', field:'po'},
                { label:'Source', field:'source'},
                { label:'MFG', field:'mfg'},
                { label:'Use Bulding', field:'useBuilding'},
                { label:'Install Status', field:'installed'},
                { label:'Secure By Lock and Cable', field:'secureByLock'},
                { label:'Reason Not Secure', field:'reasonNotSecure'},
                { label:'Received Date', field:'receiveDate'},
                { label:'Update', field:'update'},
                { label:'Dispose Date', field:'disposeDate'},
                { label:'Dispose Site', field:'disposeSite'},
                { label:'Dispose MSO', field:'disposeMSO'},
                { label:'Transfer Letter Filed', field:'verified'}
            ]
        }
    },
    methods:{
        async loadItems()
        {
            await reportAPI.getDisposalReport()
            .then(response=>{
                this.items=response.data;
            })
            .catch(error=>{console.log(error)});
        }
    },
    mounted:function(){
        this.loadItems();
    }

}
</script>
